/* TOMA PREÇO · PDP: galeria, variantes, quantidade, Comprar agora / Adicionar ao carrinho, sticky CTA, relacionados */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function money(c) { return window.TP ? TP.money(c) : (c / 100).toFixed(2); }

  function gallery(root) {
    var track = $('[data-tp-gal-track]', root); if (!track) return null;
    var slides = track.children, thumbs = $$('[data-tp-gal-thumb]', root), dots = $$('.tp-gal__dots span', root), count = $('[data-tp-gal-count]', root);
    var cur = 0;
    function go(i, smooth) { cur = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: slides[cur].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' }); mark(cur); }
    function mark(i) {
      thumbs.forEach(function (t, k) { if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      if (count) count.textContent = (i + 1) + '/' + slides.length;
    }
    var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { cur = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); mark(cur); }, 60); }, { passive: true });
    thumbs.forEach(function (b) { b.addEventListener('click', function () { go(Number(b.getAttribute('data-tp-gal-thumb'))); }); });
    var p = $('[data-tp-gal-prev]', root), n = $('[data-tp-gal-next]', root);
    if (p) p.addEventListener('click', function () { go(cur - 1); });
    if (n) n.addEventListener('click', function () { go(cur + 1); });
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') go(cur + 1); if (e.key === 'ArrowLeft') go(cur - 1); });
    return { toMedia: function (id) { for (var i = 0; i < slides.length; i++) if (String(slides[i].getAttribute('data-media-id')) === String(id)) { go(i); return; } } };
  }

  function init() {
    var root = $('[data-tp-pdp]'); if (!root) return;
    var data = {}; try { data = JSON.parse($('[data-tp-product-json]').textContent); } catch (e) { return; }
    var gal = gallery(root);
    var form = $('[data-tp-product-form]', root), idInput = $('[data-tp-variant-id]', root);
    var buyBtns = $$('[data-tp-buynow]'), addBtn = $('[data-tp-addcart]', root), err = $('[data-tp-buy-err]', root);
    var stock = $('[data-tp-stock]', root), ship = $('[data-tp-ship]', root);
    var variant = data.variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || data.variants[0];

    function selected() { return $$('[data-tp-option]', root).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
    function update(v) {
      variant = v;
      if (!v) { buyBtns.concat([addBtn]).forEach(function (b) { if (b) b.disabled = true; }); if (stock) { stock.textContent = 'Combinação indisponível'; stock.className = 'tp-stock tp-stock--out'; } return; }
      idInput.value = v.id;
      $$('[data-tp-price-now]', root).forEach(function (el) { el.textContent = money(v.price); });
      var sp = $('[data-tp-sticky-price]'); if (sp) sp.textContent = money(v.price);
      var was = $('.tp-price__was', root);
      if (was) { if (v.compare_at_price > v.price) { was.hidden = false; was.lastChild.textContent = money(v.compare_at_price); } else was.hidden = true; }
      $$('[data-tp-sku-value]').forEach(function (el) { el.textContent = v.sku || ''; });
      var skuOk = !!v.sku && !/^(VD-|SKU_|sA)/.test(v.sku) && !/\d{10,}/.test(v.sku); // F-19: SKU legado ou técnico (≥10 dígitos seguidos) não aparece
      $$('[data-tp-sku], [data-tp-spec-sku]').forEach(function (el) { el.hidden = !skuOk; });
      buyBtns.concat([addBtn]).forEach(function (b) { if (b) b.disabled = !v.available; });
      if (stock) { stock.textContent = v.available ? 'Disponível' : 'Indisponível no momento'; stock.className = 'tp-stock ' + (v.available ? 'tp-stock--in' : 'tp-stock--out'); }
      if (ship) { ship.setAttribute('data-variant-id', v.id); ship.dispatchEvent(new CustomEvent('tp:variant', { detail: v })); }
      if (v.media_id && gal) gal.toMedia(v.media_id);
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
    }
    $$('[data-tp-option]', root).forEach(function (fs, idx) {
      fs.addEventListener('change', function () {
        var sel = selected();
        var lbl = $('[data-tp-option-label]', fs), c = $('input:checked', fs); if (lbl && c) lbl.textContent = c.value;
        update(data.variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0]);
        // marca valores sem estoque considerando as outras opções escolhidas
        $$('[data-tp-option]', root).forEach(function (f2, j) {
          $$('.tp-opt__val', f2).forEach(function (l) {
            var val = $('input', l).value;
            var ok = data.variants.some(function (v) { return v.available && v.options[j] === val && v.options.every(function (o, i) { return i === j || o === sel[i]; }); });
            l.classList.toggle('is-unavailable', !ok);
          });
        });
      });
    });

    // quantidade
    var qty = $('[data-tp-qty]', root);
    if (qty) {
      var qi = $('input', qty), minus = $('[data-tp-qty-minus]', qty), plus = $('[data-tp-qty-plus]', qty);
      var sync = function () { var n = Math.max(1, Math.min(99, parseInt(qi.value, 10) || 1)); qi.value = n; minus.disabled = n <= 1; };
      minus.addEventListener('click', function () { qi.value = (parseInt(qi.value, 10) || 1) - 1; sync(); });
      plus.addEventListener('click', function () { qi.value = (parseInt(qi.value, 10) || 1) + 1; sync(); });
      qi.addEventListener('change', sync);
    }
    function items() { return [{ id: Number(idInput.value), quantity: Math.max(1, parseInt((qty && $('input', qty).value) || '1', 10)) }]; }
    function fail(e) {
      if (!err) return; var m = e && e.message ? e.message : '';
      err.textContent = /estoque|stock|inventory|dispon/i.test(m) ? 'Quantidade indisponível em estoque.' : (m || 'Não foi possível adicionar. Tente novamente.');
      err.hidden = false;
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault(); if (!window.TP || addBtn.disabled) return;
      err.hidden = true; addBtn.setAttribute('aria-busy', 'true');
      TP.cart.add(items()).catch(fail).then(function () { addBtn.removeAttribute('aria-busy'); });
    });
    buyBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled || !window.TP) return;
        err.hidden = true; b.setAttribute('aria-busy', 'true');
        // mesmo fluxo de checkout usado hoje pela loja: adiciona e segue para /checkout (integrações de checkout intocadas)
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items() }) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message); return j; }); })
          .then(function () { location.href = '/checkout'; })
          .catch(function (e) { b.removeAttribute('aria-busy'); fail(e); });
      });
    });

    // sticky CTA mobile: aparece quando os botões principais saem da tela
    var sticky = $('[data-tp-sticky]'), actions = $('[data-tp-actions]', root);
    if (sticky && actions && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        $$('button', sticky).forEach(function (b) { b.tabIndex = show ? 0 : -1; });
        document.body.classList.toggle('tp-has-sticky', show);
      }, { threshold: 0 }).observe(actions);
    }

    // relacionados (Section Rendering API), carregados perto da viewport
    var rel = $('[data-tp-related]', root);
    if (rel) {
      var load = function () {
        fetch(rel.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
          var d = document.createElement('div'); d.innerHTML = html;
          var s = d.querySelector('.tp-shelf'); if (s) { rel.appendChild(s); if (window.TP) { TP.initScrollers(rel); TP.fav.sync(); } }
        }).catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px' }); io.observe(rel);
      } else load();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
